import { TTrueFalseAnswer } from '~/pages/anatomyV2/libs/components/TrueFalseQuestionTemplate/constants'
import { PageId } from '~/shared/constants/pagesConstants'

// Single source of truth for each True/False question's correct answer —
// used both by the question page itself and by the section-complete screen
// that tallies up how many were answered correctly.
export const TRUE_FALSE_CORRECT_ANSWERS: Partial<
  Record<PageId, TTrueFalseAnswer>
> = {
  [PageId.SPOT_THE_FAKE_ANATOMY_V2_1]: 'true',
  [PageId.SPINE_POSTURE_ANATOMY_V2_1]: 'false',
  [PageId.WATER_DIGESTION_ANATOMY_V2_1]: 'false',
  [PageId.HIP_FLEXOR_ANATOMY_V2_1]: 'true',
}
